import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { VALUES } from "./data";

export const Wood = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const clip = useTransform(scrollYProgress, [0, 0.4], ["inset(18% 12% 18% 12% round 32px)", "inset(0% 0% 0% 0% round 32px)"]);

  return (
    <section id="legno" ref={ref} data-testid="wood-section" className="bg-[#1A110C] text-[#FDFBF7] py-24 sm:py-36 grain relative overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#E8893F] mb-6">Il nostro legno</p>
          <h2 className="font-serif text-5xl sm:text-7xl lg:text-[7.5rem] leading-[0.9] tracking-[-0.02em] max-w-5xl">
            Vero legno <em className="text-[#E8893F]">di abete.</em> Niente di più, niente di meno.
          </h2>
        </Reveal>

        <motion.div style={{ clipPath: clip }} className="mt-16 sm:mt-24 relative h-[50vh] sm:h-[70vh] overflow-hidden">
          <motion.img style={{ y }} src="/img/forest.jpg" alt="Tronchi di abete" className="absolute inset-0 w-full h-[125%] -top-[12%] object-cover" />
          <div className="absolute inset-0 bg-[#1A110C]/25" />
        </motion.div>

        <div className="mt-16 sm:mt-24 grid md:grid-cols-3 gap-px bg-[#FDFBF7]/15 border-y border-[#FDFBF7]/15">
          {VALUES.map((v, i) => (
            <Reveal key={v.k} delay={i * 0.1} className="bg-[#1A110C] py-10 md:px-8 first:md:pl-0">
              <div data-testid={`value-${i}`} className="group">
                <span className="text-xs uppercase tracking-[0.3em] text-[#E8893F]">0{i + 1} — {v.k}</span>
                <h3 className="mt-5 font-serif text-3xl sm:text-4xl leading-tight group-hover:italic transition-all">{v.v}</h3>
                <p className="mt-4 text-sm sm:text-base text-[#F4EFE6]/75 leading-relaxed">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
